import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../../modules';
import { ContentsItem } from '../../../modules/editor/types';
import { service } from '../../../config';
import { parseStyle } from '../../../util/parseStyle';

import SnsToolbar from '../Toolbar/SnsToolbar';

type Props = {
	contentItem: ContentsItem
};

const SnsItem = (item:any) => {	
	if (!item.active) { 
		return null;
	}

	const itemStyle = () => {
		return {
			padding: item.isFirst ? '0 10px 0 0' : item.isLast ? '0 0 0 10px' : '0 10px 0 10px' ,
			display: 'inline-block',
		}
	}

	return (
		<span
			style={itemStyle()}	
		>
			<img 
				src={`${service.resource}/editor/icon/sns/${item.value}-${item.snsStyle}.png`} 
				alt={item.label} 
				width="30"
				style={{
					verticalAlign: 'middle'
				}}
			/>
		</span>
	)
}

function Sns({ contentItem }: Props) {
	const [showToolbar, setShowToolbar] = useState(false);	

	const selectedContentId = useSelector((state: RootState) => state.editor.selectedContentId);

	useEffect(() => {
		if (selectedContentId !== contentItem.id) {
			unselectContent();
		}
	}, [selectedContentId]);

	const startEditing = () => {
		setShowToolbar(true);
	}

	const unselectContent = () => {
		setShowToolbar(false);
	}

	return (
		<div className={showToolbar ? 'sns-edit active' : 'sns-edit'}>
			<div className="sns-edit-content">
			{
				contentItem.content.content[0].sns.map((item:any, index:number) => (
					<SnsItem 
						key={index} 
						isFirst={index === 0}
						isLast={index === contentItem.content.content[0].sns?.length - 1}
						snsStyle={contentItem.content.style[0].box.snsStyle} 
						{...item} 
					/>
				))
			}
			</div>
			{
				showToolbar ? (
					<SnsToolbar
						innerContent={contentItem.content.content[0]}
						style={contentItem.content.style[0].box}
						contentId={contentItem.id}
						contentIndex={0}
					/>
				) : (
					<div
						className="cover"
						onClick={startEditing}
					>
					</div>
				)
			}
		</div>
	)
}

export default Sns;